import { palettes, spacers } from '@trainline/depot-web/css';
import { StyleSheet } from 'aphrodite/no-important';

export default StyleSheet.create({
  journey: {
    display: 'flex',
    flexFlow: 'row',
    padding: `${spacers.dp_s12} ${spacers.dp_s24}`,
    border: `1px solid ${palettes.dp_app_border_base}`,
    borderTop: 0,
    borderRight: 0,
    ':last-child': {
      borderBottom: 0,
    },
  },
});
